// extracted by mini-css-extract-plugin
export var bodySections = "_94-8";
export var gray = "_94-7";
export var green = "_94-4";
export var iconContainer = "_94-9";
export var iconWidgetContainer = "_94-1";
export var phoneIcon = "_94-2";
export var red = "_94-5";
export var statusDot = "_94-3";
export var widgetContainer = "_94-0";
export var yellow = "_94-6";